import { useRef, useState } from "react"
import dynamic from "next/dynamic"
import cn from "classnames"
import QuyTrinhTiepNhanVaGiaiQuyetKhieuNai from "components/Policy/QuyTrinhTiepNhanVaGiaiQuyetKhieuNai"
import ChinhSachBaoVeNguoiDung from "components/Policy/ChinhSachBaoVeNguoiDung"

const Navbar = dynamic(() => import("components/common/Navbar"), { ssr: false })

const TABS = [
  { label: "Quy trình tiếp nhận và giải quyết khiếu nại", Component: QuyTrinhTiepNhanVaGiaiQuyetKhieuNai },
  { label: "Chính sách bảo vệ quyền lợi người tiêu dùng dễ bị tổn thương", Component: ChinhSachBaoVeNguoiDung }
]

export default function HoTro() {
  const [isMobile, setIsMobile] = useState(false)
  // eslint-disable-next-line no-unused-vars
  const [isCollapsed, setIsCollapsed] = useState(false)
  const [activeTab, setActiveTab] = useState(0)
  const scrollRef = useRef(null)

  // Cuộn lên đầu khi đổi tab
  const handleTabChange = (index) => {
    setActiveTab(index)
    if (scrollRef.current) scrollRef.current.scrollTop = 0
  }

  const ActiveComponent = TABS[activeTab].Component

  return (
    <>
      <Navbar isMobile={isMobile} setIsMobile={setIsMobile} setIsCollapsed={setIsCollapsed} />
      <div className="h-[100vh] bg-[#0A0A0A] text-white flex flex-col">
        {/* Mobile layout */}
        <div className="flex flex-1 min-h-0 flex-col lg:hidden px-4 py-4 pt-16">
          <h1 className="px-4 py-3 text-xl font-semibold">Trung tâm hỗ trợ</h1>
          {/* Mobile tabs - fixed top */}
          <div className="flex shrink-0 gap-2 overflow-x-auto w-full border-b border-white/10 [scrollbar-width:thin]">
            {TABS.map((tab, index) => (
              <button
                key={tab.label}
                onClick={() => handleTabChange(index)}
                className={cn(
                  "whitespace-nowrap px-3 py-2 text-xs font-medium sm:text-sm text-secondary shrink-0",
                  activeTab === index ? "text-[#FAFAF9] border-b-2 border-white" : "hover:text-primary"
                )}
              >
                {tab.label}
              </button>
            ))}
          </div>

          {/* Mobile content - scrollable */}
          <div className="flex-1 min-h-0 pt-3">
            <div
              ref={scrollRef}
              style={{ WebkitOverflowScrolling: "touch" }}
              className="h-full overflow-y-auto overscroll-contain p-3 bg-[#1A1A1A] rounded-lg text-sm leading-relaxed [&_a]:text-primary [&_a]:underline [&_p]:mb-3"
            >
              <ActiveComponent isShow={true} />
            </div>
          </div>
        </div>

        {/* Desktop layout */}
        <div className="hidden lg:flex flex-1 min-h-0 px-10 lg:px-44 xl:px-80 py-4 pt-24 gap-6">
          {/* Desktop sidebar - fixed left */}
          <aside className="w-72 shrink-0 flex flex-col gap-1">
            {TABS.map((tab, index) => (
              <button
                key={tab.label}
                onClick={() => handleTabChange(index)}
                className={cn(
                  "w-full h-14 rounded-lg px-4 py-2 text-left text-sm font-medium bg-[#1B1B1B]",
                  activeTab === index ? "!bg-primary text-[#FAFAF9]" : "text-secondary hover:bg-white/10"
                )}
              >
                {tab.label}
              </button>
            ))}
          </aside>

          {/* Desktop content - scrollable */}
          <div className="flex-1 min-h-0">
            <div
              ref={scrollRef}
              style={{ WebkitOverflowScrolling: "touch" }}
              className="h-full overflow-y-auto overscroll-contain p-4 bg-[#1A1A1A] rounded-lg text-sm leading-relaxed [&_a]:text-primary [&_a]:underline [&_p]:mb-3"
            >
              <ActiveComponent isShow={true} />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
